import { ValueObject } from "./common";
import { I18Text } from "./i18Text";
import { LabelType } from "./label";
import ProductTypes from "./productType";

export type ProductCategory = {
  icon: PublicDisplayImageType;
  code: string;
  section: string;
  displayName: I18Text;
  active: boolean;
  seq: number;
  type: ProductTypes;
  externalLink?: string;
  labels?: LabelType[];
};

export type PublicDisplayImageType = {
  code: string;
  url: string;
  insurer?: string;
  title?: string;
};

export type BannerDisplayImageType = {
  code: string;
  desktopUrl: string;
  mobileUrl: string;
  title?: string;
};

export type CoverageItemType = {
  code: string;
  displayName: I18Text;
  valueType: ValueType;
  detail?: I18Text;
  favorableValue?: FavorableValueType;
  type: keyof typeof CoverageType;
  isShowInPlanCard?: boolean;
};

export enum FavorableValueType {
  "greater" = "greater",
  "lesser" = "lesser",
  "true" = "true",
  "false" = "false",
  "null" = "null",
}

export enum ValueType {
  "integer" = "integer",
  "boolean" = "boolean",
  "number" = "number",
  "string" = "string",
}

export enum AvailableValuesType {
  "GMD_CODE" = "GMD_CODE",
  "FE_EMBEDDED" = "FE_EMBEDDED",
  "PROVIDED" = "PROVIDED",
  "GMD_PROVIDED" = "GMD_PROVIDED",
}

export type AvailableValuesItems = {
  value: string | number;
  label?: I18Text;
};

export type CarInfoItem = {
  label: string;
  logoImageUrl?: string;
  value: string;
};

export type RecommendItem = {
  value: string | number;
};

export type PopularItem = {
  value: string | number;
};

export type FieldValidationsDefType = {
  rule: string;
};

export type SupportedInputCodesType = {
  inputCode: string;
  validations?: FieldValidationsDefType[] | null;
};

export type FieldValidationConfigType = {
  rule: string;
  params?: ValueObject<any>;
};

export type FieldAvailableValueConfigType = {
  type: keyof typeof AvailableValuesType;
  code?: string;
  items?: AvailableValuesItems[];
  recommendItems?: RecommendItem[];
  popularItems?: PopularItem[];
};

export type ActiveInputCodesType = {
  inputCode: string;
  validations?: FieldValidationConfigType[] | null;
  availableValues?: FieldAvailableValueConfigType;
};

export type EntryFormType = {
  code: string;
  supportedInputCodes: SupportedInputCodesType[];
  activeInputCodes: ActiveInputCodesType[];
};

export type LinkTermsAndConditionsType = {
  text: I18Text;
  url: I18Text;
  color: string;
};

export type ConfigParameterType = {
  linkTermsAndConditions: LinkTermsAndConditionsType;
};

export type ProductCategoryPromotionType = {
  show: boolean;
  message: I18Text;
  startDate: Date;
  endDate: Date;
  parameters: ConfigParameterType;
  bgColor: string;
  borderColor: string;
};

export type ProductCategoryRecommendPlanItemsType = {
  title: I18Text;
  subTitle: I18Text;
  logoUrl: string;
  link: I18Text;
};

export type ProductCategoryRecommendPlanType = {
  title: I18Text;
  enabled: boolean;
  maxDisplayItem: number;
  items?: ProductCategoryRecommendPlanItemsType[];
};

export type ProductCategoryTagType = {
  code: string;
  displayName: I18Text;
};

export type ProductCategoryTagsType = {
  [TagCategory: string]: ProductCategoryTagType[];
};

export type ProductCategoryType = {
  contentTitle?: I18Text;
  contentDescription?: I18Text;
  code: string;
  promotion: ProductCategoryPromotionType;
  recommendPlan: ProductCategoryRecommendPlanType;
  displayName: I18Text;
  active: boolean;
  section: string;
  icon: PublicDisplayImageType;
  banner: BannerDisplayImageType;
  labels?: LabelType[];
  seq: number;
  contentCode: string;
  coverageItems?: CoverageItemType[];
  type: ProductTypes;
  entryForm?: EntryFormType;
  externalLink?: string;
  tags: ProductCategoryTagsType;
  productCategoryTemplate?: string;
  productSpecificConfig?: ProductSpecificConfigType;
};

export type ProductSpecificConfigType = {
  carOptionType?: string;
  dropLeadOnlyItems?: DropLeadOnlyItemType;
};

export type DropLeadOnlyItemType = {
  carMakes?: string[];
};

export enum CoverageType {
  "main" = "main",
  "other" = "other",
  "additional" = "additional",
}

export type ProductCategoryFAQType = {
  question: I18Text;
  answer: {
    th: any;
    en: any;
  };
  id?: any;
  seq?: number;
};
